/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Robotics_SummaryInputs */

const en_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A designed, rules-based, equal-weight model portfolio tracking leaders in robotics and autonomous systems, including Tesla, Nvidia, and Amazon (via tokenized stock).`)
};

const de_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleich gewichtetes Engagement in führenden Unternehmen für Entwicklung, Fertigung und Einsatz von Robotik und autonomen Systemen, darunter Tesla, NVIDIA und Amazon.`)
};

const pt_br2_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposição com pesos iguais a líderes em design, fabricação e implantação de robótica e sistemas autônomos, incluindo Tesla, NVIDIA e Amazon.`)
};

const tr_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tesla, NVIDIA ve Amazon dahil olmak üzere robotik ve otonom sistemlerin tasarımında, üretiminde ve devreye alınmasında lider şirketlere eşit ağırlıklı yatırım.`)
};

const zh_cn2_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等权重投资于机器人和自主系统设计、制造与部署领域的领军企业，包括特斯拉、英伟达和亚马逊。`)
};

const zh_hk2_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等權重投資於機械人及自主系統設計、製造與部署領域的領先企業，包括 Tesla、NVIDIA 及 Amazon。`)
};

const ko_kr2_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로보틱스와 자율 시스템의 설계, 제조, 배치를 선도하는 기업에 동일 비중으로 투자합니다. Tesla, NVIDIA, Amazon 등이 포함됩니다.`)
};

const ru_ru2_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Равновзвешенные вложения в лидеров в разработке, производстве и внедрении робототехники и автономных систем, включая Tesla, NVIDIA и Amazon.`)
};

const es_419_strategy_partner_robotics_summary = /** @type {(inputs: Strategy_Partner_Robotics_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposición de igual ponderación a líderes en el diseño, la fabricación y el despliegue de robótica y sistemas autónomos, incluidos Tesla, NVIDIA y Amazon.`)
};

/**
* | output |
* | --- |
* | "A designed, rules-based, equal-weight model portfolio tracking leaders in robotics and autonomous systems, including Tesla, Nvidia, and Amazon (via tokenized..." |
*
* @param {Strategy_Partner_Robotics_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_robotics_summary = /** @type {((inputs?: Strategy_Partner_Robotics_SummaryInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Robotics_SummaryInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_robotics_summary(inputs)
	if (locale === "de") return de_strategy_partner_robotics_summary(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_robotics_summary(inputs)
	if (locale === "tr") return tr_strategy_partner_robotics_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_robotics_summary(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_robotics_summary(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_robotics_summary(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_robotics_summary(inputs)
	return es_419_strategy_partner_robotics_summary(inputs)
});